import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import {Router, ActivatedRoute} from '@angular/router';
import { CountryService } from '../country.service';
import {NgForm} from '@angular/forms';

declare var $: any;
declare var Nanobar: any;
declare var google: any;
declare var toastr: any;

@Component({
  selector: 'app-driver-report-detail',
  templateUrl: './driver-report-detail.component.html',
  styleUrls: ['./driver-report-detail.component.css']
})
export class DriverReportDetailComponent implements OnInit {
  id: any;
  private sub: any;
  showRangeFields = false;
  nao = new Nanobar();
  driverReportData: any;
  type: any;
  startDate: any;
  endDate: any;
  total_earning: any;
  typeString = 'Today';
  earning_list: any;
  rangeData = false;
  constructor(private route: ActivatedRoute, private dataService: DataService, private router: Router,  private cs: CountryService) {
    this.sub = this.route.params.subscribe(params => {
       this.id = +params['id']; // (+) converts string 'id' to a number
      console.log('this.id', this.id);
    });
  }
   updateData(type) {
    if (type === 'today') {
      this.showRangeFields = false;
      this.typeString = 'Today';
      this.rangeData = false;
      this.reportDetailData(1, this.startDate, this.endDate);
    }
    if (type === 'weekly') {
      this.showRangeFields = false;
      this.typeString = 'Past 7 days';
      this.rangeData = false;
      this.reportDetailData(2, this.startDate, this.endDate);
    }
    if (type === 'monthly') {
      this.showRangeFields = false;
      this.typeString = 'Past 30 days';
      this.rangeData = false;
      this.reportDetailData(3, this.startDate, this.endDate);
    }
    if (type === 'selectRange') {
      this.showRangeFields = true;
      this.typeString = 'past 30 days';
      this.rangeData = true;
      setTimeout(() => {
      $('#datepickerDriverReportStart, #datepickerDriverReportEnd').datepicker({
        format: 'yyyy-m-d', // Notice the Extra space at the beginning
        defaultDate: '-10d',
        endDate: new Date()
      });
      }, 1000);
      // this.reportDetailData(4);
    }
  }
  reportDetailData(type, start_date, end_date) {
    this.nao.go(30);
    this.dataService.driverReportDetail(window.localStorage.getItem('token'), this.id, type, start_date, end_date).subscribe(
      (data) => {
        this.nao.go(100);
        console.log('customer data', data);
        this.driverReportData = data;
        this.earning_list = data;
        this.earning_list = this.earning_list.earning_list;
        this.total_earning = this.driverReportData.total_earning;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  sendRangeData() {
    this.startDate = $('#datepickerDriverReportStart').val();
    this.endDate = $('#datepickerDriverReportEnd').val();
    if (this.startDate === '' || this.startDate === undefined) {
      toastr.error('please select start date');
      return;
    }
    if (this.endDate === '' || this.endDate === undefined) {
      toastr.error('please select end date');
      return;
    }
    this.rangeData = false;
    console.log('this.startDate,this.endDate', this.startDate, this.endDate);
    this.typeString = 'From ' + this.startDate + ' ' + 'To ' + this.endDate;
    this.reportDetailData(4, this.startDate, this.endDate);
  }
  restrictUserInput($event) {
    $event.preventDefault();
  }
  ngOnInit() {
    this.reportDetailData(1, this.startDate, this.endDate);
    // this.maxYear =new Date().getFullYear();
    //     this.maxYear = parseInt(this.maxYear) - 21;
  }

}



// WEBPACK FOOTER //
// ./src/app/driver-report-detail/driver-report-detail.component.ts